export const BYTES_PER_MEGABYTE = 1024 * 1024
